import {
    GET_PEOPLE,
    FILTER_PEOPLE,
    CLEAR_PEOPLE,
    CLEAR_FILTERED,
    REQUEST_COMPARE_FAILED,
    REQUEST_COMPARE_PENDING,
    REQUEST_COMPARE_SUCCESS
} from "../actiontypes";

const INITIAL_STATE = {
    unfiltered: [],
    filtered: [],
    openCaseChecked: false,
    isPending: false,
    errors: ""
};

/* PeopleReducer => 
    GET_PEOPLE - Adds People On Search 
    FILTER_PEOPLE - Filters Those With Cases
    CLEAR_PEOPLE - Cleans Array 
*/
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_PEOPLE:
            return { ...state, unfiltered: action.payload };
        case FILTER_PEOPLE:
            return {
                ...state,
                filtered: action.payload,
                openCaseChecked: true
            };
        case CLEAR_PEOPLE:
            return {
                ...state,
                unfiltered: [],
                filtered: [],
                openCaseChecked: false
            };
        case CLEAR_FILTERED:
            return {
                ...state,
                filtered: [],
                openCaseChecked: false
            };
        case REQUEST_COMPARE_PENDING:
            return { ...state, isPending: true };
        case REQUEST_COMPARE_SUCCESS:
            return { ...state, unfiltered: action.payload, isPending: false };
        case REQUEST_COMPARE_FAILED:
            return { ...state, error: action.payload, isPending: false };
        default:
            return state;
    }
};
